import GroupsIngestionPosthogJs from "../../../../contents/manual/snippets/groups-ingestion-posthog-js.mdx";
import GroupsIngestionPython from "../../../../contents/manual/snippets/groups-ingestion-python.mdx";
import GroupsIngestionPHP from "../../../../contents/manual/snippets/groups-ingestion-php.mdx";
import GroupsIngestionGo from "../../../../contents/manual/snippets/groups-ingestion-go.mdx";
import GroupsIngestionNode from "../../../../contents/manual/snippets/groups-ingestion-node.mdx";
import GroupsIngestionSegment from "../../../../contents/manual/snippets/groups-ingestion-segment.mdx";
import GroupsIngestionOther from "../../../../contents/manual/snippets/groups-ingestion-other.mdx";
import Tab from "components/Tab";
import GroupsFeatureFlagsPosthogJs from "../../../../contents/manual/snippets/groups-flags-posthog-js.mdx";
import GroupsFeatureFlagsPython from "../../../../contents/manual/snippets/groups-flags-python.mdx";
import GroupsFeatureFlagsPHP from "../../../../contents/manual/snippets/groups-flags-php.mdx";
import GroupsFeatureFlagsGo from "../../../../contents/manual/snippets/groups-flags-go.mdx";
import GroupsFeatureFlagsNode from "../../../../contents/manual/snippets/groups-flags-node.mdx";
import * as React from 'react';
export default {
  GroupsIngestionPosthogJs,
  GroupsIngestionPython,
  GroupsIngestionPHP,
  GroupsIngestionGo,
  GroupsIngestionNode,
  GroupsIngestionSegment,
  GroupsIngestionOther,
  Tab,
  GroupsFeatureFlagsPosthogJs,
  GroupsFeatureFlagsPython,
  GroupsFeatureFlagsPHP,
  GroupsFeatureFlagsGo,
  GroupsFeatureFlagsNode,
  React
};